// //new filter ui
// import React, { useState, useRef, useEffect } from 'react'; 
// import './BigFilter.css';
// import { FiFilter } from 'react-icons/fi';

// const BigFilter = ({ 
//   options, 
//   value, 
//   onChange, 
//   placeholder,
//   style 
// }) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [activeSection, setActiveSection] = useState(null);
//   const [tempValue, setTempValue] = useState(value);
//   const selectRef = useRef(null);

//   const handleToggle = () => {
//     setIsOpen(!isOpen);
//     if (!isOpen && options.length > 0) {
//       setActiveSection(options[0]?.title);
//       setTempValue(value);
//     }
//   };

//   const handleTempOptionChange = (option) => {
//     const newValues = tempValue.includes(option)
//       ? tempValue.filter((val) => val !== option)
//       : [...tempValue, option];
//     setTempValue(newValues);
//   };

//   const handleClear = () => {
//     setTempValue([]);
//     onChange([]);
//   };

//   const handleClickOutside = (event) => {
//     if (selectRef.current && !selectRef.current.contains(event.target)) {
//       setIsOpen(false);
//     }
//   };

//   useEffect(() => {
//     document.addEventListener('mousedown', handleClickOutside);
//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, []);

//   const hasActiveFilters = () => {
//     return tempValue.length > 0;
//   };

//   const getFilterCount = (sectionTitle) => {
//     const section = options.find(opt => opt.title === sectionTitle);
//     if (!section) return 0;

//     return tempValue.filter(val =>
//       section.items.some(item => item.value === val)
//     ).length;
//   };

//   const getActiveSectionItems = () => {
//     if (!activeSection) return [];
//     const section = options.find(opt => opt.title === activeSection);
//     return section ? section.items : [];
//   };

//   useEffect(() => {
//     setTempValue(value);
//   }, [value]);

//   return (
//     <div className="Big-filter" style={style}>
//       <div
//         className={`Bigfilter-header ${hasActiveFilters() ? 'Bighas-filters' : ''}`}
//         onClick={handleToggle}
//       >
//         <FiFilter className="Bigfilter-icon" size={24} />
//         <span className="Bigfilter-placeholder">
//           {placeholder}
//           {hasActiveFilters() && (
//             <span className="Bigfilter-count-badge">
//               {tempValue.length}
//             </span>
//           )}
//         </span>
//       </div>

//       {isOpen && (
//         <div className="Bigfilter-overlay">
//           <div className="Bigfilter-container" style={{ width: '700px' }} ref={selectRef}>
//             {/* Header with buttons at top right */}
//             <div className="Bigfilter-header-top">
//               <div className="Bigfilter-title">Filters</div>
//               <div className="Bigfilter-top-buttons">
//                 <button
//                   className="clear-btn"
//                   onClick={handleClear}
//                   disabled={!hasActiveFilters()}
//                 >
//                   CLEAR ALL
//                 </button>
//                 <button
//                   className="apply-btn"
//                   onClick={() => {
//                     onChange(tempValue);
//                     setIsOpen(false);
//                   }}
//                 >
//                   APPLY
//                 </button>
//               </div>
//             </div>

//             <div className="Bigfilter-main-content">
//               <div className="Bigfilter-sidebar">
//                 {options.map((section) => {
//                   const count = getFilterCount(section.title);
//                   return (
//                     <div
//                       key={section.title}
//                       className={`Big-filter-sidebar-item ${activeSection === section.title ? 'Big-active' : ''}`}
//                       onClick={() => setActiveSection(section.title)}
//                     >
//                       <span>{section.title}</span>
//                       {count > 0 && <span className="Big-filter-badge">{count}</span>}
//                     </div>
//                   );
//                 })}
//               </div>

//               <div className="Big-filter-content">
//                 <div className="scrollable-content">
//                   {activeSection && (
//                     <>
//                       {/* <div className="content-section">
//                         <div className="content-title">{activeSection}</div>
//                       </div> */}
//                       <div className="content-options">
//                         {getActiveSectionItems().length === 0 ? (
//                           <div className="no-results">No options available</div>
//                         ) : (
//                           getActiveSectionItems().map((option) => (
//                             <div key={option.value} className="option-item">
//                               <input
//                                 type="checkbox"
//                                 id={option.value}
//                                 checked={tempValue.includes(option.value)}
//                                 onChange={() => handleTempOptionChange(option.value)}
//                               />
//                               <label htmlFor={option.value}>
//                                 {option.label}
//                               </label>
//                             </div>
//                           ))
//                         )}
//                       </div>
//                     </>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default BigFilter;

//new filter ui
import React, { useState, useRef, useEffect } from 'react';
import './BigFilter.css';
import { FiFilter } from 'react-icons/fi';

const BigFilter = ({
  options,
  value,
  onChange,
  showDateRange = false,
  selectedStartDate,
  selectedEndDate,
  onDateRangeSelected,
  placeholder,
  style
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeSection, setActiveSection] = useState(null);
  const [tempValue, setTempValue] = useState(value);
  const [tempStartDate, setTempStartDate] = useState(selectedStartDate || '');
  const [tempEndDate, setTempEndDate] = useState(selectedEndDate || '');
  const selectRef = useRef(null);

  const handleToggle = () => {
    setIsOpen(!isOpen);
    if (!isOpen && options.length > 0) {
      setActiveSection(options[0]?.title);
      setTempStartDate(selectedStartDate || '');
      setTempEndDate(selectedEndDate || '');
      setTempValue(value);
    }
  };

  const handleTempOptionChange = (option) => {
    const newValues = tempValue.includes(option)
      ? tempValue.filter((val) => val !== option)
      : [...tempValue, option];
    setTempValue(newValues);
  };

  const handleClear = () => {
    setTempValue([]);
    setTempStartDate('');
    setTempEndDate('');
    onChange([]);
    if (showDateRange && onDateRangeSelected) {
      onDateRangeSelected('', '');
    }
  };

  const handleDateInputChange = (type, dateValue) => {
    if (type === 'start') {
      setTempStartDate(dateValue);
    } else {
      setTempEndDate(dateValue);
    }
  };

  const handleApply = () => {
    onChange(tempValue);
    if (showDateRange && onDateRangeSelected) {
      onDateRangeSelected(tempStartDate, tempEndDate);
    }
    setIsOpen(false);
  };

  const handleClickOutside = (event) => {
    if (selectRef.current && !selectRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const hasActiveFilters = () => {
    return tempValue.length > 0 || (tempStartDate && tempEndDate);
  };

  const getFilterCount = (sectionTitle) => {
    if (sectionTitle === 'Date Range') {
      return (tempStartDate && tempEndDate) ? 1 : 0;
    }

    const section = options.find(opt => opt.title === sectionTitle);
    if (!section) return 0;

    return tempValue.filter(val =>
      section.items.some(item => item.value === val)
    ).length;
  };

  const getActiveSectionItems = () => {
    if (!activeSection) return [];
    
    if (activeSection === 'Date Range') {
      return [];
    }
    
    const section = options.find(opt => opt.title === activeSection);
    return section ? section.items : [];
  };

  const getAllSections = () => {
    const allSections = [...options];
    if (showDateRange) {
      allSections.push({ title: 'Date Range', items: [] });
    }
    return allSections;
  };

  useEffect(() => {
    setTempValue(value);
    setTempStartDate(selectedStartDate || '');
    setTempEndDate(selectedEndDate || '');
  }, [value, selectedStartDate, selectedEndDate]);

  return (
    <div className="Big-filter" style={style}>
      <div
        className={`Bigfilter-header ${hasActiveFilters() ? 'Bighas-filters' : ''}`}
        onClick={handleToggle}
      >
        <FiFilter className="Bigfilter-icon" size={24} />
        <span className="Bigfilter-placeholder">
          {placeholder}
          {hasActiveFilters() && (
            <span className="Bigfilter-count-badge">
              {tempValue.length + ((tempStartDate && tempEndDate) ? 1 : 0)}
            </span>
          )}
        </span>
      </div>

      {isOpen && (
        <div className="Bigfilter-overlay">
          <div className="Bigfilter-container" style={{ width: '700px' }} ref={selectRef}>
            {/* Header with buttons at top right */}
            <div className="Bigfilter-header-top">
              <div className="Bigfilter-title">Filters</div>
              <div className="Bigfilter-top-buttons">
                <button
                  className="clear-btn"
                  onClick={handleClear}
                  disabled={!hasActiveFilters()}
                >
                  CLEAR ALL
                </button>
                <button
                  className="apply-btn"
                  onClick={handleApply}
                >
                  APPLY
                </button>
              </div>
            </div>

            <div className="Bigfilter-main-content">
              <div className="Bigfilter-sidebar">
                {getAllSections().map((section) => {
                  const count = getFilterCount(section.title);
                  return (
                    <div
                      key={section.title}
                      className={`Big-filter-sidebar-item ${activeSection === section.title ? 'Big-active' : ''}`}
                      onClick={() => setActiveSection(section.title)}
                    >
                      <span>{section.title}</span>
                      {count > 0 && <span className="Big-filter-badge">{count}</span>}
                    </div>
                  );
                })}
              </div>

              <div className="Big-filter-content">
                <div className="scrollable-content">
                  {activeSection && (
                    <>
                      <div className="content-options">
                        {activeSection === 'Date Range' ? (
                          <div className="date-range-section" style={{ padding: '10px' }}>
                            <div style={{ marginBottom: '15px' }}>
                              <label htmlFor="start-date" style={{ 
                                display: 'block', 
                                marginBottom: '5px', 
                                fontWeight: '500',
                                fontSize: '14px'
                              }}>
                               From
                              </label>
                              <input
                                id="start-date"
                                type="date"
                                value={tempStartDate}
                                onChange={(e) => handleDateInputChange('start', e.target.value)}
                                style={{
                                  width: '100%',
                                  padding: '8px 12px',
                                  border: '1px solid #ddd',
                                  borderRadius: '4px',
                                  fontSize: '14px'
                                }}
                              />
                            </div>
                            <div>
                              <label htmlFor="end-date" style={{ 
                                display: 'block', 
                                marginBottom: '5px', 
                                fontWeight: '500',
                                fontSize: '14px'
                              }}>
                                To
                              </label>
                              <input
                                id="end-date"
                                type="date"
                                value={tempEndDate}
                                onChange={(e) => handleDateInputChange('end', e.target.value)}
                                style={{
                                  width: '100%',
                                  padding: '8px 12px',
                                  border: '1px solid #ddd',
                                  borderRadius: '4px',
                                  fontSize: '14px'
                                }}
                              />
                            </div>
                            {/* {(tempStartDate || tempEndDate) && (
                              <div style={{ marginTop: '10px' }}>
                                <button
                                  onClick={() => {
                                    setTempStartDate('');
                                    setTempEndDate('');
                                  }}
                                  style={{
                                    padding: '6px 12px',
                                    backgroundColor: '#f5f5f5',
                                    border: '1px solid #ddd',
                                    borderRadius: '4px',
                                    fontSize: '12px',
                                    cursor: 'pointer'
                                  }}
                                >
                                  Clear Dates
                                </button>
                              </div>
                            )} */}
                          </div>
                        ) : getActiveSectionItems().length === 0 ? (
                          <div className="no-results">No options available</div>
                        ) : (
                          getActiveSectionItems().map((option) => (
                            <div key={option.value} className="option-item">
                              <input
                                type="checkbox"
                                id={option.value}
                                checked={tempValue.includes(option.value)}
                                onChange={() => handleTempOptionChange(option.value)}
                              />
                              <label htmlFor={option.value}>
                                {option.label}
                              </label>
                            </div>
                          ))
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BigFilter;